import { toJS } from 'mobx';
import { BaseRequests } from '../BaseRequests';

export class ArticlesRequests extends BaseRequests {
  #store;

  #api;

  #addToast;

  #projId;

  #portfolioId;

  constructor({
    api, addToast, store, projId, portfolioId,
  }) {
    super();
    this.#api = api;
    this.#addToast = addToast;
    this.#store = store;
    this.#projId = projId;
    this.#portfolioId = portfolioId;
  }

  getOptions = async (inputValue, callback) => {
    if (!inputValue || inputValue.length < 5) {
      return callback([]);
    }
    const result = await this.#api.get(`/pure/articles?search=${inputValue.trim()}`);
    callback(this.#mapOptionsToValues(result));
  };

  getResultsById(id) {
    const result = this.#api.get(`/pure/articles/${id}?projId=${this.#projId}`);
    return result;
  }

  updateArticles = (e) => {
    this.#store.articles.updateResultObject(...e);
  };

  deleteArticleFile = async (fileId, articleId) => {
    const url = `/factdata/articles/${articleId}/files/${fileId}`;
    await this.#api.del(url, {}).then((x) => {
      if (!x.id) {
        this.#addToast.error('Файл не удалось удалить');
      } else {
        this.#addToast.success('Файл удален');
        this.#store.resultObject = { ...this.#store.resultObject, file: null };
      }
    });
  };

  getArticleById = (id) => {
    const result = this.#api.get(`/factdata/articles/${id}`);
    return result;
  };

  saveArticle = (articleObject) => {
    const checkId = Number.isNaN(Number(articleObject.id)) ? 0 : Number(articleObject.id);
    const body = {
      id: checkId,
      projId: +this.#projId,
      pureId: Number.isNaN(Number(articleObject.id)) ? articleObject.id : articleObject.pureId,
      highlyCitedPaper: articleObject.highlyCitedPaper,
      isPriorityFinSource: articleObject.isPriorityFinSource,
    };
    const saveId = `/${checkId}`;
    const result = this.#api.post(`/factdata/articles${Number.isNaN(Number(articleObject.id)) ? '' : saveId}`, body,true);
    const file = (this.#store.articles.resultObject?.file?.length && !this.#store.articles.resultObject?.file[0]?.id) ? { ...this.#store.articles.resultObject.file } : null;
    result
      .then(async (data) => {
        // eslint-disable-next-line no-unused-expressions
        !!file && await this.#api.postFormData(`/factdata/articles/${data.id}/files`, {}, file[0]);
        return data;
      })
      .then((x) => this.getArticleById(x.id))
      .then((element) => this.#store.articles.setResultObject(element.article))
      .then(() => this.#store.articles.clearCheckBoxResult())
      .then(() => this.#addToast.success('Статья успешно сохранена'))
      .catch((err) => {
        this.#addToast.error(err);
      });
  };

  getAllArticles = () => {
    const url = BaseRequests.getUrlSearch('/factdata/articles', {
      projId: this.#projId,
      portfId: this.#portfolioId,
      year: this.#store.articles.filters?.year,
      status: this.#store.articles.filters.status?.value,
    });
    const allTable = this.#api
      .get(url)
      .then((x) => {
        for (const val of x.data) {
          val.highlyCitedPaperString = val.highlyCitedPaper ? 'Да' : 'Нет';
          val.isPriorityFinSourceString = val.isPriorityFinSource ? 'Да' : 'Нет';
        }
        return x;
      })
      .then((x) => this.#store.articles.updateAllArticles(x));

    return allTable;
  };

  getAllPortfolioArticles = () => {
    const url = BaseRequests.getUrlSearch('/factdata/articles', {
      portfId: this.#portfolioId,
      year: this.#store.articles.filters?.year,
      status: this.#store.articles.filters.status?.value,
    });
    const allTable = this.#api
      .get(url).then((x) => {
        this.#store.articles.updateAllArticles(x);
      });
    return allTable;
  };

  // eslint-disable-next-line class-methods-use-this
  #mapOptionsToValues = (options) =>
  // value, label, isFixed, isDisabled
    options.map((option) => ({
      value: option.id,
      label: `${option.articleName}`,
    }));

  deleteArticleById = async (id) => {
    const result = this.#api.delWithPromise(`/factdata/articles/${id}`)
      .catch((err) => this.#addToast.success(err));
    return this.#store.articles?.allArticles?.data
      ? result
        .then(() => {
          const arts = [...toJS(this.#store.articles.allArticles.data)].filter((r) => r.id !== id);
          this.#addToast.success('Статья была удалена');
          return this.#store.articles.updateAllArticles({ data: arts, count: arts.length });
        })
      : result
        .then(() => this.#addToast.success('Статья была удалена'));
  };

  sendArticle = async (id) => {
    const result = await this.#api.post(`/factdata/articles/${id}/send`);
    if (result && !result.error) {
      if (this.#store.articles.resultObject) this.#store.articles.updateResultObject('onApprove', 'status');
      const arts = [...toJS(this.#store.articles.allArticles.data)];
      const a = arts.find((t) => t.id === id);
      a.status = result.status;
      this.#addToast.success('Статья отправлена на согласование');
      return this.#store.articles.updateAllArticles({ data: arts, count: arts.length });
    }
    return false;
  };

  rejectArticle = async (id, comment) => {
    const result = await this.#api.post(`/factdata/articles/${id}/reject`, { comment });
    if (result && !result.error) {
      const arts = [...toJS(this.#store.articles.allArticles.data)];
      const a = arts.find((t) => t.id === id);
      a.status = result.status;
      a.comment = result.comment;
      this.#addToast.success('Статья не согласована');
      return this.#store.articles.updateAllArticles({ data: arts, count: arts.length });
    }
    return false;
  };

  approveArticle = async (id) => {
    const result = await this.#api.post(`/factdata/articles/${id}/approve`);
    if (result && !result.error) {
      const arts = [...toJS(this.#store.articles.allArticles.data)];
      const a = arts.find((t) => t.id === id);
      a.status = result.status;
      a.comment = null;
      this.#addToast.success('Статья согласована');
      return this.#store.articles.updateAllArticles({ data: arts, count: arts.length });
    }
    return false;
  };
}
